<div class="divider !k-mt-0"></div>
<div class="section k-p-6 !k-pt-0">
    <form class="k-form k-form-md" [formGroup]="mailToForm" *ngIf="mailToForm">
        <h3 class="section__heading !k-pb-6">Mail To</h3>
        <div class="subsection">
            <h4 class="subsection__heading !k-mt-0">Recipient</h4>
            <div class="k-mt-2 k-d-grid k-grid-cols-4 k-gap-4">
                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="always">
                    <kendo-label text="Recipient Contact *">
                    </kendo-label>
                    <kendo-dropdownlist [data]="contactList" textField="description" valueField="id" rounded="large"
                        size="large" formControlName="recipientContact">
                        <ng-template kendoDropDownListNoDataTemplate>
                            <div class="no-records-found">
                                <div class="bold-text">No contacts available.</div>
                                <div>This student has no eligible contacts to select from. Please check student profile
                                    for
                                    more info.</div>
                            </div>
                        </ng-template>
                    </kendo-dropdownlist>
                    <kendo-formerror *ngIf="mailToForm.get('recipientContact').errors?.required">
                        Required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="always">
                    <kendo-label text="Name *" [for]="recipientName">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientName" #recipientName>
                    </kendo-textbox>
                    <kendo-formerror>
                        {{ mailToForm.get('recipientName')?.errors?.validateName?.message }}
                    </kendo-formerror>
                </kendo-formfield>


                <kendo-formfield class="!k-mt-0 k-col-span-2" showHints="always" showErrors="always">

                    <kendo-label text="Email Address" [for]="recipientEmail">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientEmail" #recipientEmail>
                    </kendo-textbox>
                    <kendo-formerror>
                        {{ mailToForm.get('recipientEmail')?.errors?.validateEmail?.message }}
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="always">
                    <kendo-label text="Street Number *" [for]="recipientAddress">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientAddress" #recipientAddress>
                    </kendo-textbox>
                    <kendo-formerror>{{ mailToForm.get('recipientAddress')?.errors?.validateAddress?.message
                        }}</kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0 k-col-span-2" showHints="always" showErrors="always">
                    <kendo-label text="Street Name *" class="k-form-label" [for]="recipientAddress2">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientAddress2" #recipientAddress2>
                    </kendo-textbox>
                    <kendo-formerror>{{ mailToForm.get('recipientAddress2')?.errors?.validateAddress?.message
                        }}</kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0">
                    <kendo-label text="Apartment Number" class="k-form-label" [for]="apartmentNumber">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientApartmentNumber" #apartmentNumber>
                    </kendo-textbox>
                    <kendo-formerror>{{ mailToForm.get('recipientApartmentNumber')?.errors?.validateAddress?.message
                        }}</kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0 k-col-span-2" showHints="always" showErrors="always">

                    <kendo-label text="City *" [for]="recipientCity">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientCity" #recipientCity>
                    </kendo-textbox>
                    <kendo-formerror>{{ mailToForm.get('recipientCity')?.errors?.validateCity?.message
                        }}</kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="always">
                    <kendo-label text="State *" [for]="recipientState">
                    </kendo-label>
                    <kendo-dropdownlist [data]="referenceData.state" textField="description" valueField="id"
                        rounded="large" [valuePrimitive]="true" size="large" formControlName="recipientState"
                        #recipientState>
                    </kendo-dropdownlist>
                    <kendo-formerror *ngIf="mailToForm.get('recipientState').errors?.required">
                        Required
                    </kendo-formerror>
                </kendo-formfield>

                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="always">
                    <kendo-label text="Zip *" [for]="recipientZip">
                    </kendo-label>
                    <kendo-textbox [clearButton]="true" size="large" rounded="large" fillMode="outline"
                        formControlName="recipientZip" #recipientZip>
                    </kendo-textbox>
                    <kendo-formerror>{{ mailToForm.get('recipientZip')?.errors?.validateZipCode?.message
                        }}</kendo-formerror>
                </kendo-formfield>
            </div>

            <h4 class="subsection__heading">Method of Delivery *</h4>
            <div>Please indicate how you intend to send the document to the recipient.</div>
            <div class="k-d-flex k-gap-4">
                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="initial">
                    <div class="k-mt-2">
                        <input type="checkbox" size="medium" rounded="large" kendoCheckBox #postalMailRef
                            formControlName="postalMail" />
                        <kendo-label class="k-checkbox-label" [for]="postalMailRef" text="Postal Mail" />
                    </div>
                </kendo-formfield>
                <kendo-formfield class="!k-mt-0" showHints="always" showErrors="initial">
                    <div class="k-mt-2">
                        <input type="checkbox" size="medium" rounded="large" kendoCheckBox #parentPortalRef
                            formControlName="parentPortal" />
                        <kendo-label class="k-checkbox-label" [for]="parentPortalRef" text="Parent Portal" />
                    </div>
                </kendo-formfield>
            </div>
            <kendo-formerror *ngIf="(mailToForm.controls.parentPortal?.errors?.required || mailToForm.controls.postalMail?.errors?.required) && 
                        (mailToForm.controls.parentPortal?.touched || mailToForm.controls.postalMail?.touched)">
                Error: Please select at least one method of delivery
            </kendo-formerror>
        </div>
    </form>
</div>